import { render, staticRenderFns } from "./simulate.voyage.desktop.vue?vue&type=template&id=50dfea76&scoped=true"
import script from "./simulate.voyage.desktop.vue?vue&type=script&lang=js"
export * from "./simulate.voyage.desktop.vue?vue&type=script&lang=js"
import style0 from "./simulate.voyage.desktop.vue?vue&type=style&index=0&id=50dfea76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dfea76",
  null
  
)

export default component.exports